/* AC Asia Carrocería — Menú móvil V2 (v9: logos Changan/GAC + versiones reales de miniaturas; v8: +Changan +GAC +Emgrand +X70 1g/2g +T1 +Coolray 26-27 +Cityray) */
(function () {
  if (window.__acMenuInit) return;
  window.__acMenuInit = true;

  var CDN = 'https://cdn.shopify.com/s/files/1/0776/5265/6355/files/';
  var WA = 'https://wa.me/50767742662';

  function assetBase() {
    try {
      var s = document.querySelector('script[src*="ac-menu"]');
      if (!s || !s.src) return null;
      return s.src.substring(0, s.src.lastIndexOf('/') + 1);
    } catch (e) { return null; }
  }
  var ASSETS = assetBase();

  var BRANDS = [
    { key: 'geely', nm: 'Geely', ini: 'GE', lider: true, logoCdn: 'Logo_geely.png?v=1784429402', models: [
      { nm: 'Coolray 2019-2022', col: 'geely-coolray-2019-2022', img: 'Geely_coolray.png?v=1782583351', hot: true, stock: true },
      { nm: 'Coolray 2023-2025', col: 'geely-coolray-2023-2025', img: 'Geely_Coolray_2023_a_2025.png?v=1782015109', stock: true },
      { nm: 'Coolray 2026-2027', col: 'geely-coolray-2026-2027', img: 'Geely_Coolray_2026-2027.png?v=1782011958' },
      { nm: 'GX3 Pro', col: 'geely-gx3-pro', img: 'Geely_gx3.png?v=1781576539', stock: true },
      { nm: 'Starray', col: 'geely-starray', img: 'Geely_Starray.png?v=1782011924', stock: true },
      { nm: 'Emgrand', col: 'geely-emgrand', img: 'Geely_Emgrand.png?v=1782055907' },
      { nm: 'Cityray', col: 'geely-cityray', img: 'Geely_Cityray.png?v=1782011861' }
    ]},
    { key: 'jetour', nm: 'Jetour', ini: 'JT', logoCdn: 'Logo_Jetour.png?v=1784429422', models: [
      { nm: 'Dashing', col: 'jetour-dashing', img: 'Dashing.png?v=1781576518', stock: true },
      { nm: 'T1', col: 'jetour-t1', img: 'Jetour_T1.png?v=1782055828' },
      { nm: 'T2', col: 'jetour-t2', img: 'Jetour_T2.png?v=1782011885' },
      { nm: 'X70 2018-2023', col: 'jetour-x70-2018-2023', img: 'Jetour_x70_2018_-_2023.png?v=1782056412' },
      { nm: 'X70 2023-2027', col: 'jetour-x70-2024-2027', img: 'Jetour_x70_2024_-_2027.png?v=1782055807' },
      { nm: 'X70 Plus', col: 'jetour-x70-plus', img: 'Jetour_x70_plus.png?v=1783131313' }
    ]},
    { key: 'kaiyi', nm: 'Kaiyi', ini: 'KY', logoCdn: 'Logo_kaiyi.png?v=1784429442', models: [
      { nm: 'X7', col: 'kaiyi-x7', img: 'Kaiyix7.png?v=1781576570', stock: true }
    ]},
    { key: 'chery', nm: 'Chery', ini: 'CH', logoCdn: 'ChatGPT_Image_Jun_22_2026_11_30_05_AM.png?v=1782145843', models: [
      { nm: 'Tiggo 8 Pro', col: 'chery-tiggo-8-pro', img: 'D9E1EF38-11C6-4D74-A48C-5A3F0C7C1E7C.png?v=1786046221', zoom: true }
    ]},
    { key: 'changan', nm: 'Changan', ini: 'CA', logoCdn: 'Changan.png?v=1786841793', models: [
      { nm: 'CS35 Plus', col: 'changan-cs35-plus', img: '793BBA3B-DAFF-47AF-A96A-7DFE90227264.png?v=1785895930' }
    ]},
    { key: 'gac', nm: 'GAC', ini: 'GA', logoCdn: 'Gac.png?v=1786841809', models: [
      { nm: 'Emzoom', col: 'gac-emzoom', img: 'GAC_Emzoom.png?v=1782011995' },
      { nm: 'GS8', col: 'gac-gs8', img: 'GAC_GS8.png?v=1782011831' }
    ]}
  ];

  var IC = {
    inicio: '<svg class="acm-mi" viewBox="0 0 24 24"><path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V21h14V9.5"/></svg>',
    vin: '<svg class="acm-mi" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.5" y2="16.5"/></svg>',
    cat: '<svg class="acm-mi" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3.2"/><path d="M19 12a7 7 0 0 1-.4 2.3l2 1.6-2 3.4-2.4-1a7 7 0 0 1-2 1.2L14 22h-4l-.3-2.5a7 7 0 0 1-2-1.2l-2.4 1-2-3.4 2-1.6A7 7 0 0 1 5 12"/></svg>',
    info: '<svg class="acm-mi" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 8v.5M11 12h1v4h1"/></svg>',
    tel: '<svg class="acm-mi" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2.2 2A18 18 0 0 1 3 5.2 2 2 0 0 1 5 3h4l1.4 4.2-2 1.6a14 14 0 0 0 6.8 6.8l1.6-2L21 15z"/></svg>'
  };

  var MENU = [
    { nm: 'Inicio', url: '/', ic: IC.inicio },
    { nm: 'Buscador por VIN', url: '/pages/buscador', ic: IC.vin },
    { nm: 'Categorías', ic: IC.cat, sub: [
      { nm: 'Iluminación', url: '/collections/iluminacion' },
      { nm: 'Parachoques', url: '/collections/parachoques' },
      { nm: 'Carrocería', url: '/collections/carroceria' },
      { nm: 'Espejos', url: '/collections/espejos' },
      { nm: 'Puertas y Cerraduras', url: '/collections/puertas-y-cerraduras' },
      { nm: 'Molduras y Sellos', url: '/collections/molduras-y-sellos' }
    ]},
    { nm: 'Sobre nosotros', url: '/pages/sobre-nosotros', ic: IC.info },
    { nm: 'Contacto', url: '/pages/contact', ic: IC.tel }
  ];

  var ARROW = '<svg class="acm-arrow" viewBox="0 0 24 24"><path d="m9 6 6 6-6 6"/></svg>';
  var WASVG = '<svg viewBox="0 0 24 24"><path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zm5.8 14.01c-.24.68-1.42 1.31-1.96 1.35-.5.05-.99.24-3.35-.7-2.83-1.11-4.62-3.98-4.76-4.17-.14-.19-1.14-1.52-1.14-2.9 0-1.38.72-2.06.98-2.34.24-.26.54-.33.72-.33.18 0 .36 0 .52.01.17.01.4-.06.62.47.24.57.81 1.96.88 2.1.07.14.12.31.02.5-.09.19-.14.31-.28.47-.14.17-.29.37-.42.5-.14.14-.28.28-.12.55.17.28.74 1.22 1.59 1.98 1.1.98 2.02 1.28 2.3 1.42.28.14.44.12.6-.07.17-.19.7-.81.88-1.09.18-.28.37-.23.62-.14.25.09 1.6.75 1.87.89.28.14.46.21.53.32.07.12.07.68-.17 1.35z"/></svg>';
  var SIL = '<svg viewBox="0 0 100 60"><path d="M10 40c2-8 8-14 16-16l6-8c2-3 5-4 9-4h20c4 0 7 1 9 4l6 8c8 2 14 8 16 16v6c0 2-1 3-3 3h-5a7 7 0 0 1-13 0H32a7 7 0 0 1-13 0h-6c-2 0-3-1-3-3z"/></svg>';

  function cnt(handle) {
    var c = (window.__ACMenuCounts || {})[handle];
    return (typeof c === 'number' && c > 0) ? c : null;
  }
  function brandTotal(b) {
    var c = cnt(b.key);
    if (c) return c;
    var s = 0;
    b.models.forEach(function (m) { s += cnt(m.col) || 0; });
    return s || null;
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }

  function brandAvatar(b) {
    var src = null;
    if (b.logoAsset && ASSETS) src = ASSETS + b.logoAsset;
    else if (b.logoCdn) src = CDN + b.logoCdn + '&width=120';
    if (src) {
      return '<span class="acm-bwrap"><img class="acm-bfoto" loading="lazy" src="' + src + '" alt="' + esc(b.nm) + '"><span class="acm-bini acm-escondido">' + b.ini + '</span></span>';
    }
    return '<span class="acm-bwrap"><span class="acm-bini">' + b.ini + '</span></span>';
  }

  function build() {
    var wrap = document.querySelector('#navigation-mobile .halo-sidebar-wrapper');
    if (!wrap || document.getElementById('ac-menu-root')) return;

    var root = document.createElement('div');
    root.id = 'ac-menu-root';

    var logoHtml = ASSETS
      ? '<img class="acm-logoimg" src="' + ASSETS + 'ac-logo-color-menu.png" alt="AC Asia Carrocería"><span class="acm-logo acm-escondido">AC <b>ASIA CARROCERÍA</b></span>'
      : '<span class="acm-logo">AC <b>ASIA CARROCERÍA</b></span>';

    var h = '';
    h += '<div class="acm-head">' + logoHtml + '<button type="button" class="acm-x" aria-label="Cerrar menú">✕</button></div>';
    h += '<div class="acm-tabs" role="tablist">';
    h += '<button type="button" class="acm-tab on" data-tab="menu">Menú</button>';
    h += '<button type="button" class="acm-tab" data-tab="modelos">Modelos</button>';
    h += '</div>';

    h += '<div class="acm-panel" data-panel="menu">';
    MENU.forEach(function (it) {
      if (it.sub) {
        h += '<div class="acm-item"><button type="button" class="acm-fila" data-acc>' + it.ic + esc(it.nm) + ARROW + '</button><div class="acm-subl">';
        it.sub.forEach(function (s) { h += '<a href="' + s.url + '">' + esc(s.nm) + '</a>'; });
        h += '</div></div>';
      } else {
        h += '<a class="acm-fila" href="' + it.url + '">' + it.ic + esc(it.nm) + '</a>';
      }
    });
    h += '</div>';

    h += '<div class="acm-panel acm-oculto" data-panel="modelos">';
    h += '<div class="acm-nivel-marcas"><div class="acm-brands">';
    BRANDS.forEach(function (b) {
      var tot = brandTotal(b);
      var sub = (tot ? tot + ' piezas · ' : '') + b.models.length + (b.models.length === 1 ? ' modelo' : ' modelos');
      h += '<button type="button" class="acm-bcard' + (b.lider ? ' acm-lider' : '') + '" data-brand="' + b.key + '">';
      h += brandAvatar(b);
      h += '<span class="acm-binfo"><span class="acm-bnm">' + esc(b.nm) + '</span><span class="acm-bpz">' + sub + '</span></span>';
      h += ARROW + '</button>';
    });
    h += '</div>';
    h += '<a class="acm-wa" href="' + WA + '" target="_blank" rel="noopener">' + WASVG + '<span><span class="t1">¿Otra marca china?</span><span class="t2">Escríbenos · lo conseguimos por ti</span></span></a>';
    h += '</div>';

    BRANDS.forEach(function (b) {
      var tot = brandTotal(b);
      h += '<div class="acm-nivel-modelos acm-escondido" data-mpanel="' + b.key + '">';
      h += '<button type="button" class="acm-volver"><svg viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"/></svg>Marcas</button>';
      h += '<div class="acm-mtit">' + esc(b.nm) + (tot ? '<small>' + tot + ' piezas disponibles</small>' : '') + '</div>';
      h += '<div class="acm-modelos">';
      b.models.forEach(function (m) {
        var c = cnt(m.col);
        var pz = (c ? c + ' piezas' : 'Ver piezas') + (m.stock ? ' · <b>con stock local</b>' : '');
        var foto = m.img
          ? (m.zoom
              ? '<span class="acm-mfoto" style="overflow:hidden;padding:0"><img loading="lazy" src="' + CDN + m.img + '&width=220" alt="" style="width:100%;height:100%;object-fit:contain;transform:scale(1.3);display:block"></span>'
              : '<img class="acm-mfoto" loading="lazy" src="' + CDN + m.img + '&width=120" alt="">')
          : '<span class="acm-mfb">' + SIL + '</span>';
        h += '<a class="acm-mrow' + (m.hot ? ' acm-hot' : '') + '" href="/collections/' + m.col + '">';
        h += foto;
        h += '<span class="acm-minfo"><span class="acm-mnm">' + esc(m.nm) + '</span><span class="acm-mpz">' + pz + '</span></span>';
        h += ARROW + '</a>';
      });
      h += '</div></div>';
    });

    h += '</div>';

    root.innerHTML = h;
    wrap.appendChild(root);

    var li = root.querySelector('.acm-logoimg');
    if (li) {
      li.addEventListener('error', function () {
        li.classList.add('acm-escondido');
        var txt = root.querySelector('.acm-head .acm-logo');
        if (txt) txt.classList.remove('acm-escondido');
      });
    }

    root.querySelectorAll('.acm-bwrap .acm-bfoto').forEach(function (img) {
      img.addEventListener('error', function () {
        img.classList.add('acm-escondido');
        var ini = img.parentNode.querySelector('.acm-bini');
        if (ini) ini.classList.remove('acm-escondido');
      });
    });

    root.querySelectorAll('img.acm-mfoto').forEach(function (img) {
      img.addEventListener('error', function () {
        var f = document.createElement('span');
        f.className = 'acm-mfb';
        f.innerHTML = SIL;
        if (img.parentNode) img.parentNode.replaceChild(f, img);
      });
    });

    root.querySelector('.acm-x').addEventListener('click', function () {
      var btn = document.querySelector('#navigation-mobile [data-menu-close-sidebar]');
      if (btn) { btn.click(); return; }
      var sb = document.getElementById('navigation-mobile');
      if (sb) sb.classList.remove('is-open', 'active', 'open');
      document.body.classList.remove('open-sidebar', 'sidebar-open', 'overflow-hidden');
    });

    root.querySelectorAll('.acm-tab').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('.acm-tab').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        root.querySelectorAll('.acm-panel').forEach(function (p) { p.classList.add('acm-oculto'); });
        var target = root.querySelector('[data-panel="' + t.getAttribute('data-tab') + '"]');
        if (target) target.classList.remove('acm-oculto');
      });
    });

    root.querySelectorAll('[data-acc]').forEach(function (b) {
      b.addEventListener('click', function () { b.parentElement.classList.toggle('acm-abierto'); });
    });

    var panelMod = root.querySelector('[data-panel="modelos"]');
    root.querySelectorAll('.acm-bcard').forEach(function (b) {
      b.addEventListener('click', function () {
        panelMod.querySelector('.acm-nivel-marcas').classList.add('acm-escondido');
        var mp = panelMod.querySelector('[data-mpanel="' + b.getAttribute('data-brand') + '"]');
        if (mp) mp.classList.remove('acm-escondido');
        panelMod.scrollTop = 0;
      });
    });
    root.querySelectorAll('.acm-volver').forEach(function (v) {
      v.addEventListener('click', function () {
        panelMod.querySelectorAll('.acm-nivel-modelos').forEach(function (m) { m.classList.add('acm-escondido'); });
        panelMod.querySelector('.acm-nivel-marcas').classList.remove('acm-escondido');
      });
    });

    var container = document.getElementById('navigation-mobile');
    if (container) container.classList.add('ac-menu-on');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
  var tries = 0;
  var iv = setInterval(function () {
    if (document.getElementById('ac-menu-root') || ++tries > 20) { clearInterval(iv); return; }
    build();
  }, 500);
})();

/* === AC Galería de producto: una imagen a la vez con swipe (independiente de clases del contenedor) === */
(function () {
  if (window.__acGalInit) return;
  window.__acGalInit = true;
  if (location.pathname.indexOf('/products/') < 0) return;

  function initGal() {
    var slides = document.querySelectorAll('.productView-image');
    if (slides.length < 2) return false;
    var parent = slides[0].parentElement;
    if (!parent) return false;
    for (var i = 1; i < slides.length; i++) {
      if (slides[i].parentElement !== parent) return false;
    }
    if (parent.dataset.acGal === '1') return true;
    if ((parent.className || '').indexOf('slick') >= 0) return true; /* el slider del tema ya funciona */
    parent.dataset.acGal = '1';
    parent.style.display = 'flex';
    parent.style.flexWrap = 'nowrap';
    parent.style.overflowX = 'auto';
    parent.style.overflowY = 'hidden';
    parent.style.scrollSnapType = 'x mandatory';
    parent.style.webkitOverflowScrolling = 'touch';
    parent.style.scrollBehavior = 'smooth';
    parent.style.gap = '0px';
    for (var j = 0; j < slides.length; j++) {
      var s = slides[j];
      s.style.flex = '0 0 100%';
      s.style.width = '100%';
      s.style.maxWidth = '100%';
      s.style.scrollSnapAlign = 'center';
      s.style.scrollSnapStop = 'always';
    }
    var st = document.createElement('style');
    st.textContent = '[data-ac-gal="1"]::-webkit-scrollbar{display:none}[data-ac-gal="1"]{scrollbar-width:none}';
    document.head.appendChild(st);
    /* Contador 1/4 */
    var box = parent.parentElement || parent;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    var ctr = document.createElement('div');
    ctr.setAttribute('style', 'position:absolute;bottom:10px;right:12px;background:rgba(0,0,0,.62);color:#fff;font-size:11px;font-weight:700;padding:4px 10px;border-radius:99px;z-index:5;pointer-events:none;font-family:inherit');
    ctr.textContent = '1 / ' + slides.length;
    box.appendChild(ctr);
    parent.addEventListener('scroll', function () {
      var idx = Math.round(parent.scrollLeft / parent.clientWidth) + 1;
      if (idx < 1) idx = 1;
      if (idx > slides.length) idx = slides.length;
      ctr.textContent = idx + ' / ' + slides.length;
    }, { passive: true });
    return true;
  }

  function boot() {
    if (initGal()) return;
    var n = 0;
    var iv = setInterval(function () {
      if (initGal() || ++n > 25) clearInterval(iv);
    }, 400);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();